const closeBtn = document.querySelector('.js-close');
const mess = document.querySelector('.header__mess');

if (closeBtn && mess) {
  closeBtn.addEventListener('click', function () {
    mess.style.transition = 'opacity 0.3s';
    mess.style.opacity = '0';
    setTimeout(() => mess.style.display = 'none', 300);
  });
}
